/* eslint-disable */
import Flickity from 'flickity'
let relatedProductsFlkty;

export default related => {
  let slideshow = related.querySelector('.js-product-slideshow')
  let containsDoubleWide = related.querySelector('.double-wide')
  let mobileView = window.matchMedia("(max-width:768px)").matches
  
  createFlickity(related, slideshow, containsDoubleWide, mobileView)

  $(window).on('resize', () => {
    slideshow = related.querySelector('.js-product-slideshow')
    containsDoubleWide = related.querySelector('.double-wide')
    mobileView = window.matchMedia("(max-width:768px)").matches
    createFlickity(related, slideshow, containsDoubleWide, mobileView)
  })
}
const createFlickity = (related, slideshow, containsDoubleWide, mobileView) => {
  if (!relatedProductsFlkty && slideshow && containsDoubleWide || !relatedProductsFlkty && slideshow && mobileView) {
    const relatedProductsFlkty = new Flickity(slideshow, {
      contain: true,
      prevNextButtons: false,
      groupCells: true,
      pageDots: false,
      imagesLoaded: true,
      draggable: true
    })

    relatedProductsFlkty.on('dragStart', (event, pointer) => { document.ontouchmove = e => e.preventDefault() })
    relatedProductsFlkty.on('dragEnd', (event, pointer) => { document.ontouchmove = e => true })

    setTimeout(() => {
      relatedProductsFlkty && relatedProductsFlkty.resize()
    }, 1500)

    $(window).on('load resize scroll', () => {
      relatedProductsFlkty && relatedProductsFlkty.resize()
    })

    const arrows = related.querySelector('.js-carousel-arrows')
    const leftArrow = related.querySelector('.js-carousel-left')
    const rightArrow = related.querySelector('.js-carousel-right')

    arrows.classList.remove('hidden')
    leftArrow.addEventListener('click', () => relatedProductsFlkty.previous())
    rightArrow.addEventListener('click', () => relatedProductsFlkty.next())
  }
  else if (relatedProductsFlkty && !containsDoubleWide && !mobileView) {
    const arrows = related.querySelector('.js-carousel-arrows')
    arrows.classList.add('hidden')
    relatedProductsFlkty.destroy()
    relatedProductsFlkty = undefined;
  }
  else if (!relatedProductsFlkty) {
    const arrows = related.querySelector('.js-carousel-arrows')
    arrows.classList.add('hidden')
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/related-products.js